import { render, staticRenderFns } from "./listaArticoli.vue?vue&type=template&id=1671c21b&"
import script from "./listaArticoli.vue?vue&type=script&lang=js&"
export * from "./listaArticoli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports